import dispatcher from '../modules/dispatcher/router'
import menuManagementRoutes from '../modules/menu-management/router'
import shiftAndReportsRoutes from '../modules/shift-and-reports/router'

export default [
    {
        path: '/orders',
        name: 'order-list',
        meta: {
            showCallingFrame: true,
            permission: 'order.list',
            isOrderList: true,
            allowMobile: true,
        },
        component: () => import('../views/orders-list/OrderList.vue'),
    },

    {
        // order
        path: '/orders/edit/:id',
        name: 'order-edit',
        meta: {
            showCallingFrame: true,
            permission: 'order',
            allowMobile: true,
        },
        component: () => import('../views/orders-edit/Order.vue'),
    },
    {
        path: '/orders/new',
        name: 'order-new',
        meta: {
            showCallingFrame: true,
            permission: 'order',
            allowMobile: true,
        },
        component: () => import('../views/orders-edit/Order.vue'),
    },
    {
        path: '/ticket-time',
        name: 'ticket-time',
        meta: {
            permission: 'ticket-time.edit',
            isForeman: true,
            allowMobile: true,
        },
        component: () => import('../views/ticket_time/TicketTime.vue'),
    },
    {
        path: '/orders-department',
        name: 'order-department',
        meta: {
            showCallingFrame: true,
            allowMobile: true,
            permission: 'order-department.list',
            isOrderDepartment: true,
        },
        component: () =>
            import('../views/orders-department/DepartmentView.vue'),
    },
    {
        path: '/monitoring',
        name: 'monitoring',
        meta: {
            showCallingFrame: true,
            permission: 'monitoring.list',
        },
        component: () => import('../views/monitoring/MonitoringList.vue'),
    },
    {
        path: '/robot',
        name: 'robot',
        meta: {
            showCallingFrame: false,
            permission: 'robot.list',
            isRobot: true,
        },
        component: () => import('../views/robot/RobotControl.vue'),
    },
    {
        path: '/robot-history',
        name: 'robot-history',
        meta: {
            showCallingFrame: false,
            permission: 'robot.list',
            isRobot: true,
        },
        component: () => import('../views/robot/RobotHistory.vue'),
    },
    {
        path: '/division-notes',
        name: 'division-notes',
        meta: {
            permission: 'order.list',
        },
        component: () =>
            import('../views/division-notes/DivisionNotesList.vue'),
    },

    {
        path: '/foreman',
        name: 'foreman',
        component: () => import('../views/foreman/Foreman.vue'),
        meta: {
            permission: 'foreman.list',
            isForeman: true,
            allowMobile: true,
        },
    },
    {
        // TODO права по ролям
        path: '/notifications',
        name: 'notifications',
        component: () => import('../views/notifications/Notifications.vue'),
        meta: {
            permission: 'foreman.list',
            isForeman: true,
        },
    },
    {
        path: '/foreman-ticket-time',
        name: 'foreman-ticket-time',
        meta: {
            permission: 'foreman.list',
            isForeman: true,
            allowMobile: true,
        },
        component: () => import('../views/ticket_time/TicketTime.vue'),
    },

    ...menuManagementRoutes,
    ...shiftAndReportsRoutes,
    ...dispatcher
]
